export function notFoundPageLoading(resp = {}) {
  return {
    type: 'NOT_FOUND_LOADING',
    notFoundPage: resp
  };
}

export function notFoundPageLoaded(resp = {}) {
  return {
    type: 'NOT_FOUND_LOADED',
    notFoundPage: resp
  };
}

export function notFoundPageLoadError(error) {
  return {
    type: 'NOT_FOUND_ERROR',
    notFoundPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/action_creators/not_found_page_action_creators.js